const styles = {
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
    map: {
        height: 300
    },
    buttons: {
        float: 'right'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/mediatypes/MediaTypePage/MediaTypePage.css.js